import { Component, OnInit } from '@angular/core';
import { App, Nav, NavController, ViewController } from 'ionic-angular';
import { PremiumPaymentPage } from '../premium-payment/premium-payment';
import { AdsProvider } from '../../../providers/ads/ads';
declare let Stripe: any;

@Component({
  selector: 'page-premium-banner',
  templateUrl: 'premium-banner.html',
})
export class PremiumBannerPage implements OnInit {

  constructor(
    private viewCtrl: ViewController,
    private ads: AdsProvider
  ) { }

  ngOnInit(): void {
    // this.ads.hide(true);
    this.ads.isLocked = true;
  }

  async dismiss(premiumRedirect: boolean = false) {
    this.viewCtrl.dismiss(premiumRedirect).then(() => {
      this.ads.isLocked = false;
      // this.ads.show();
    });
    // let stripe = Stripe('pk_live_51IefWZEfWOjwetWPU7hpUsj3lIDQ7ziEQsRz62QIMnMhwK3WIgw0i8MWsK1kNDIzm5wSZikS7NYXeFgmfazOcaks0070GwcWzm');

    // const { result, error } = await stripe.redirectToCheckout({
    //   items: [{ plan: 'YOUR_PLAN_ID', quantity: 1 }],
    //   successUrl: 'https://example.com/success',
    //   cancelUrl: 'https://example.com/cancel',
    // });

    // if (error) {
    //   console.error(error);
    // }
  }
}



// WEBPACK FOOTER //
// /src/pages/premium/premium-banner/premium-banner.ts